import { AuthenticatedLayout, type AuthenticatedLayoutProps } from "@sg-protect/shell";

export type FullScreenHomeAuthenticatedLayoutProps = Omit<AuthenticatedLayoutProps, "isFullScreen">;

export const FullScreenHomeAuthenticatedLayout = (props: FullScreenHomeAuthenticatedLayoutProps) => {
    return <AuthenticatedLayout {...props} isFullScreen />;
};
